import React, { useEffect, useRef } from 'react';

const TrustpilotOppLoans = () => {
  const ref = useRef(null);

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="52025de90000640005760d38"
      data-style-height="130px"
      data-style-width="100%"
      style={{ pointerEvents: 'none' }}
    >
      <a href="https://www.trustpilot.com/review/opploans.com" target="_blank" rel="noopener noreferrer">Trustpilot</a>
    </div>
  );
};
export default TrustpilotOppLoans;
